<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="structure-nxt" id="calibre_pb_12"><img alt="" class="_idgenobjectattribute1" src="OEBPS/image/_2_-_Forward_Jennifer_Grace.jpg"/></p>
<div class="calibre1" id="calibre_pb_13"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_007.vue?3ac46094